<template>
  <v-container fluid class="pa-4 pa-sm-8">
    <v-layout wrap class="d-flex">
      <v-flex>
        <h2 class="dark--text text-h5 font-weight-bold">
          <!-- <v-icon size="32" class="pb-1 dark--text me-2">mdi-account</v-icon
          > -->
          Customers (Age wise)
        </h2>
      </v-flex>
      <v-spacer></v-spacer>
      <div class="mt-4 mt-sm-0">
        <v-layout wrap>
          <v-flex class="mt-1">
            <ExportAgeWiseCustomer class="ml-sm-3" :startDate="startDate" :endDate="endDate" :headers="headers" :ageTo="ageRange[1]" :ageFrom="ageRange[0]" :areas="areas" :blocks="blocks" />
          </v-flex>
        </v-layout>
      </div>
    </v-layout>

    <AgewiseGraph />

    <v-layout class="mt-6" wrap>
      <v-flex xs8 sm2 lg2 class="">
        <v-select :items="ageList" v-model="ageRange" item-text="text" item-value="value" label="Age" dense attach solo> </v-select>
      </v-flex>

      <v-flex xs12 sm8 md2 class="ml-5">
        <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field outlined label="from date" placeholder="sddd" dense :value="formatStartDate" append-icon="fa-calendar-alt dark--text" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="startDate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 sm8 md2 class="ml-5">
        <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field outlined label="to date" dense :value="formatEndDate" append-icon="fa-calendar-alt dark--text" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="endDate"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="itemsWithSno"
      class="elevation-1"
      :options.sync="options"
      :loading="loading"
      :mobile-breakpoint="0"
      :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.customerId="{ item }">
        {{ padLeft(item.customerId, 4) }}
      </template>
      <template v-slot:item.name="{ item }">
        <router-link
          v-if="item.user"
          :to="{
            name: 'CustomerDetails',
            query: { customerId: item._id },
          }"
          class="mx-auto"
        >
          {{ item.user.firstnameEn[0].toUpperCase() + item.user.firstnameEn.substring(1) }}
          <!-- <div class="mx-1" /> -->
          {{ item.user.lastnameEn[0].toUpperCase() + item.user.lastnameEn.substring(1) }}
        </router-link>

        <!-- </v-row> -->
      </template>
      <template #item.tag="{ item }">
        <span v-for="tag in item.tags" :key="tag._id"> {{ tag.name }}<br /> </span>
      </template>

      <template v-slot:item.area="{ item }">
        <CustomerAddressColumn :address="defaultAddress(item.addressDetails)" type="area" />
      </template>

      <template v-slot:item.block="{ item }">
        <CustomerAddressColumn :address="defaultAddress(item.addressDetails)" type="block" />
      </template>

      <template v-slot:item.building="{ item }">
        <CustomerAddressColumn :address="defaultAddress(item.addressDetails)" type="building" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ExportAgeWiseCustomer from "../components/Export/ExportAgeWiseCustomer.vue";
import CustomerAddressColumn from "../components/CustomerAddressColumn.vue";
import AgewiseGraph from "../components/AgewiseGraph.vue";
import { DATE_FORMAT } from "../../utils/utils";
import moment from "moment";
import { format, parseISO } from "date-fns";
export default {
  components: {
    ExportAgeWiseCustomer,
    CustomerAddressColumn,
    AgewiseGraph,
  },
  data() {
    return {
      dialog: false,
      editDialog: false,
      search: "",
      headers: [
        {
          text: "#",
          value: "customerId",
          width: 100,
        },

        { text: "Customer Name", value: "name", width: 150 },
        { text: "Tag", value: "tag", width: 100, sortable: false },
        {
          text: "Contact Number",
          value: "user.phone",
          width: 170,
          sortable: false,
        },

        { text: "Area", value: "area", width: 150, sortable: false },
        {
          text: "Block, Street, Jedha",
          value: "block",
          width: 220,
          sortable: false,
        },
        { text: "Building", value: "building", width: 200, sortable: false },

        { text: "Age", value: "age", width: 40, sortable: false },
      ],
      genderList: [
        { text: "Male", value: "MALE" },
        { text: "Female", value: "FEMALE" },
      ],
      tags: [],
      customerList: [],
      totalItemsCount: 25,
      options: {
        itemsPerPage: 25,
        page: 1,
        sortDesc: [false],
        sortBy: [],
      },
      variables: {
        limit: 25,
        skip: 0,
        sortDesc: false,
        sortBy: "",
      },
      loading: true,
      areas: [],
      areasLoading: false,
      blocks: [],
      areaBlocks: [],
      gender: "MALE",
      filter: { tag: "", area: "", block: "" },
      ageList: [
        { text: "0-15", value: [0, 15] },
        { text: "16-30", value: [16, 30] },
        { text: "31-45", value: [31, 45] },
        { text: "46-60", value: [46, 60] },
        { text: "61-100", value: [61, 100] },
      ],
      ageRange: [0, 15],
      startDate: format(
        parseISO(
          moment()
            .subtract(30, "days")
            .toDate()
            .toISOString()
        ),
        "yyyy-MM-dd"
      ),
      endDate: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
      menuStartDate: false,
      menuEndDate: false,
    };
  },
  mounted() {},
  created() {
    if (!this.hasRole(this.AdminUserPermissions.CUSTOMER_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.getAllAreas();
    this.getAllBlocks();
  },
  apollo: {
    customerAgeWiseReport() {
      return {
        query: require("../api/customerAgeWiseReport.graphql"),
        variables: {
          // input: {
          //   limit: this.variables.limit,
          //   skip: this.variables.limit,
          //   sortDesc: false,
          //   sortBy: ""
          // },
          input: this.variables,
          filter: {
            ageFrom: this.ageRange[0],
            ageTo: this.ageRange[1],
            fromDate: this.startDate,
            toDate: this.endDate,
          },
        },
        result({ data, loading }) {
          if (data) {
            this.totalItemsCount = 0;
            console.log("data", data);
            this.loading = loading;
            this.customerList = data.customerAgeWiseReport.customers;
            this.setAreaAndBlock();
            this.totalItemsCount = data.customerAgeWiseReport.totalCount;
          }
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      if (this.customerList == null) return [];
      return this.customerList.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
    formatStartDate() {
      return this.startDate ? moment(this.startDate).format(DATE_FORMAT) : "";
    },
    formatEndDate() {
      return this.endDate ? moment(this.endDate).format(DATE_FORMAT) : "";
    },
  },
  methods: {
    setAreaAndBlock() {
      this.customerList.forEach(element => {
        if (element.addressDetails) {
          element.addressDetails.forEach(address => {
            if (address.area) {
              let area = this.areas.find(x => x._id == address.area._id);
              address.area = area;
            }
            if (address.block) {
              let block = this.blocks.find(x => x._id == address.block._id);
              address.block = block;
            }
          });
        }
      });
    },
    getAllAreas() {
      this.$apollo
        .query({
          query: require("@/customer/api/getAllAreas.graphql"),
          variables: {
            searchKey: "",
          },
        })
        .then(data => {
          let areas = data.data.getAllAreas.areas;
          areas = areas.sort((a, b) => (a.nameEn > b.nameEn ? 1 : b.nameEn > a.nameEn ? -1 : 0));

          this.areas = areas;
          this.areasLoading = false;
        });
    },
    getAllBlocks() {
      this.$apollo
        .query({
          query: require("@/customer/api/getAllBlocks.graphql"),
          variables: {
            searchKey: "",
            skip: 0,
            limit: 0,
          },
        })
        .then(data => {
          let blocks = data.data.getAllBlocks.blocks;
          blocks = blocks.sort((a, b) => (a.block > b.block ? 1 : b.block > a.block ? -1 : 0));

          this.blocks = blocks;
        });
    },
    padLeft(number, length) {
      var stringValue = "" + number;
      while (stringValue.length < length) {
        stringValue = "0" + stringValue;
      }
      return stringValue;
    },
    defaultAddress(addresses) {
      if (addresses.length > 0) {
        let defaultAddress = addresses.find(x => x.is_default == true);
        if (defaultAddress) {
          return defaultAddress;
        } else {
          return addresses[0];
        }
      }
    },
    refetechCustomers() {
      (this.variables.limit = this.options.itemsPerPage), (this.variables.skip = this.options.page * this.options.itemsPerPage - this.options.itemsPerPage);
      if (this.$apollo.queries.customerAgeWiseReport)
        this.$apollo.queries.customerAgeWiseReport.refetch({
          input: {
            limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 500,
            skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
            sortDesc: this.options.sortDesc ? this.options.sortDesc[0] : "",
            sortBy: this.options.sortBy ? this.options.sortBy[0] : "",
          },
          filter: {
            ageFrom: this.ageRange[0],
            ageTo: this.ageRange[1],
            fromDate: this.startDate,
            toDate: this.endDate,
          },
        });
    },
  },
  watch: {
    customerList: "setAreaAndBlock",
    startDate: "refetechCustomers",
    endDate: "refetechCustomers",
    options: {
      handler() {
        this.refetechCustomers();
      },
      deep: true,
    },
    ageRange: {
      handler() {
        this.refetechCustomers();
      },
      deep: true,
    },
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}

fieldset {
  background-color: white;
}
</style>
